import { Search, CancelFilled } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { IconButton } from "../iconButton/IconButton.js";
import { Input } from "../input/Input.js";
import styles from "./InputSearch.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InputSearch = ({
  label,
  className,
  onClear,
  hideSearchIcon,
  inputRef,
  containerClassName,
  ...props
}) => {
  const localRef = useRef(null);
  const mergedRefs = useCallback(ref => {
    inputRef?.(ref);
    localRef.current = ref;
  }, [inputRef]);

  // Focus input after clear
  const clear = useCallback(() => {
    onClear?.();
    localRef.current?.focus();
  }, [onClear]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.container, containerClassName),
    children: [/*#__PURE__*/_jsx(Input, {
      ...props,
      label: label ?? '',
      inputRef: mergedRefs,
      className: classNames(className, styles.input, {
        [styles.withIcon]: !hideSearchIcon,
        [styles.withClear]: !!onClear
      })
    }), !hideSearchIcon && /*#__PURE__*/_jsx(Search, {
      className: styles.searchIcon
    }), onClear && props.value && /*#__PURE__*/_jsx(IconButton, {
      onClick: clear,
      className: styles.clear,
      tertiary: true,
      children: /*#__PURE__*/_jsx(CancelFilled, {})
    })]
  });
};